import React from 'react';

import { DropdownLink } from 'src/components/DropdownLink';
import { NavigationDropdownContent } from 'src/components/NavigationDropdownContent';
import { subnavbarPrimaryItems, subnavbarSecondaryItems } from 'src/pages/utils/navigation';

interface OnDemandLearningDropdownProps {
  onDropdownItemClick: () => void;
  isMenuOpen: boolean;
  setIsOnDemandMenuOpen: (isOpen: boolean) => void;
}

export const OnDemandLearningDropdown = ({
  onDropdownItemClick,
  isMenuOpen,
  setIsOnDemandMenuOpen,
}: OnDemandLearningDropdownProps): React.ReactElement => (
  <DropdownLink title="On-demand learning" isOpen={isMenuOpen} onToggle={setIsOnDemandMenuOpen}>
    <NavigationDropdownContent
      primaryItems={subnavbarPrimaryItems}
      secondaryItems={subnavbarSecondaryItems}
      isOpen={isMenuOpen}
      onItemClick={onDropdownItemClick}
    />
  </DropdownLink>
);
